// extracted by mini-css-extract-plugin
export default {"melodyVideo":"jN-z","isFullWidth":"kN-z","landingPageVideo":"lN-z","play":"mN-z","iframeVideo":"nN-z","playHidden":"oN-z","fullwidth":"pN-z"};